:host {
  display: block;
  position: relative;
}

$horizontal_padding: calc(3 * var(--spacer));
$container_padding_top: calc(3 * var(--spacer));

gz-icon::part(svgIcon) {
  fill: var(--blue-layout-403-primary);
}

.card {
  &--wrapper {
    height: 100%;
  }
  &--content {
    padding: $container_padding_top $horizontal_padding;
    justify-content: center;

    &-wrap {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    gz-title,
    gz-text {
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &.not-available {
      opacity: 0.5;
    }

    &.compact:not(.not-available) {
      cursor: pointer;

      &:hover {
        .card--title {
          color: var(--blue-layout-300-active);
        }
      }

      &:active {
        .card--title {
          color: var(--blue-layout-501-focus);
        }
      }
    }

    &.body-image {
      display: flex;
      flex-direction: row;
      gap: 48px;

      img {
        height: 100%;
        max-height: 154px;
        min-width: 290px;
        max-width: 290px;
        object-fit: cover;
        border-radius: 4px;
      }
    }
  }

  &--intro {
    margin-top: calc(2 * var(--spacer));
  }
  &--action-button {
    margin-top: calc(4.5 * var(--spacer));
  }
  &--title {
    color: var(--body-text-arrows-400);
  }
}
